module.exports = __webpack_public_path__ + "img/Beta Digitis - Gif 2_2-390.7ae8dc7f.png";